import Patch from "@shared/models/patch-updater"

export const PLANBOOK_UPDATE_RECENT_STANDARD_SETS = {
  name: "PLANBOOK_UPDATE_RECENT_STANDARD_SETS",

  params: {
    planbookId: "string",
    standardSetIds: { type: "array", items: { type: "string" } },
  },

  patches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).set(
      "attributes.recentStandardSetIds",
      payload.standardSetIds
    ).patch

    return [patch]
  },

  undoPatches: null,

  narrative: null,
}

export default PLANBOOK_UPDATE_RECENT_STANDARD_SETS
